import { createFileRoute, redirect } from '@tanstack/react-router'

import { getPreferenceControllerFindQueryOptions } from '@/api/preference/preference'
import { SignInRoute } from '@/app/routes/sign-in'
import { getUserInfo } from '@/features/auth'
import { queryClient } from '@/shared/lib/query'
import { AppLayout } from '@/widgets/layout'
import { PageFloatingChat } from '@/widgets/mastra-chat'
import { NotificationBell } from '@/widgets/notifications'

export const Route = createFileRoute('/_app')({
  component: RouteComponent,
  loader: async ({ location }) => {
    const preferencesPrefetch = queryClient
      .ensureQueryData(getPreferenceControllerFindQueryOptions())
      .catch(() => undefined)

    try {
      const userInfo = await getUserInfo()
      await preferencesPrefetch

      return userInfo
    } catch {
      // 🤦 if both fail, redirect to sign in page
      return redirect({ to: SignInRoute.to, search: { redirectTo: location.href } })
    }
  },
})

function RouteComponent() {
  return <AppLayout notificationBell={<NotificationBell />} fab={<PageFloatingChat />} />
}
